import { CommonModule } from '@angular/common';
import { Component, inject, input, signal } from '@angular/core';
import { LoggerService } from '@/core/services/logger.service';
import { EspecialidadeRequest } from '@/core/api/sicom-api/registro/medico/especialidade/especialidade.model';
import { Pessoa } from '@/shared/models/pessoa-info.model';
import { Especialidade } from './especialidade';
import { EspecialidadeListaComponent, EspecialidadeListItem } from './especialidade-lista/especialidade-lista.component';
import { EspecialidadeService } from '@/core/api/sicom-api/registro/medico/especialidade/especialidade.service';
import { MessageService } from 'primeng/api';
import { especialidadeCreateFormToRequest, especialidadeMapper } from '@/core/api/sicom-api/registro/medico/especialidade/especialidade.mapper';

@Component({
    selector: 'app-especialidade-container',
    standalone: true,
    imports: [CommonModule, EspecialidadeListaComponent, Especialidade],
    templateUrl: './especialidade-container.html'
})
export class EspecialidadeContainer {
    private readonly logger = inject(LoggerService);
    pessoa = input<Pessoa>();
    selectedDetail = signal<EspecialidadeRequest | null>(null);
    mostrandoTelaCriacao = false;
    especialidadeService = inject(EspecialidadeService);
    messageService = inject(MessageService);

    onEspecialidadeRowClick(event: EspecialidadeListItem) {
        this.selectedDetail.set(event);
    }

    onEspecialidadeCriar() {
        this.selectedDetail.set(null);
        this.mostrandoTelaCriacao = true;
    }

    onDialogCriarFechar() {
        this.mostrandoTelaCriacao = false;
    }

    onSalvarCriacao(formValue: Partial<EspecialidadeRequest>) {
        const pessoa = this.pessoa();
        if (!pessoa) return;
        const request = especialidadeCreateFormToRequest(formValue, pessoa);
        this.especialidadeService.criar(request).subscribe({
            next: () => {
                this.logger.info('Criando especialidade...', formValue);
                this.mostrandoTelaCriacao = false;
                this.messageService.add({ severity: 'success', summary: 'Especialidade criada com sucesso' });
            },
            error: (err) => {
                // Sem toast local: o global já traz a mensagem do backend, e este nem detail tinha.
                // A tela de criação permanece aberta com os dados preenchidos.
                this.logger.error('Erro ao criar especialidade', err);
            }
        });
    }

    onSalvarEdicao(request: EspecialidadeRequest) {
        this.especialidadeService.atualizar(request).subscribe({
            next: (response) => {
                this.selectedDetail.set(response);
                this.messageService.add({ severity: 'success', summary: 'Especialidade atualizada com sucesso' });
            },
            error: (err) => {
                // Sem toast local — ver acima.
                this.logger.error('Erro ao atualizar especialidade', err);
            }
        });
    }

    onEspecialidadeVoltar() {
        this.selectedDetail.set(null);
    }

    onEspecialidadeRemover(especialidade: EspecialidadeRequest & any) {
        let mapped = especialidadeMapper(especialidade);
        this.especialidadeService.remover(mapped).subscribe(() => {
            this.selectedDetail.set(null);
            this.messageService.add({ severity: 'success', summary: 'Especialidade removida com sucesso' });
        });
    }
}
